import React from "react";
import PropTypes from "prop-types";

const SearchField = ({value, setValue}) => {

    const onChange = event => {
        event.preventDefault();
        setValue(event.target.value);
    };

    return (
        <span className="search-field">
            <i className="fa fa-search search-icon" aria-hidden="true" />
            <input type="text" onChange={onChange} placeholder="Search..." value={value}
                   aria-label="Search" data-testid="search-field" />
        </span>
    )
};
SearchField.propTypes = {
    value: PropTypes.string,
    setValue: PropTypes.func
};

export default SearchField;